var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-details-huiyi"},[_c('div',{staticClass:"info-block-main"},[_c('div',{staticClass:"huiyi-status"},[_vm._v(" 照明状态 "),_c('div',{class:{
        'huiyi-history': true,
        'huiyi-history-off': _vm.lightState,
      },on:{"click":_vm.onSwitch}},[_vm._v(" "+_vm._s(_vm.lightState ? '关灯' : '开灯')+"> ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }